const needsGeneralState = generalState =>
  !generalState.get('orgslug') || !generalState.get('username')
export default needsGeneralState
